import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { deleteJobs } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'
import { getOrm } from 'orm/selectors'

const useDeleteJobsModalMutations = () => {
  const dispatch = useDispatch()

  const handleDeleteJobs = React.useCallback(
    ({ onShowSnackbar }) => {
      dispatch(deleteJobs(onShowSnackbar))
    },
    [dispatch],
  )

  return {
    handleDeleteJobs,
  }
}

export const useDeleteJobsModalState = () => {
  const { projects } = useSelector(getOrm)

  const pks = Object.keys(projects?.meta?.selected ?? {})

  const count = pks.length

  const jobs = Object.values(projects?.items ?? {}).filter(
    (job): job is { id: number | string; name?: string } =>
      typeof job === 'object' &&
      job !== null &&
      'id' in job &&
      (typeof job.id === 'number' || typeof job.id === 'string') &&
      pks.includes(job.id.toString()),
  )

  return {
    state: {
      count,
      jobs,
      pks,
    },
  }
}

export const useDeleteJobsModal = () => {
  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleDeleteJobs } = useDeleteJobsModalMutations()

  const handleConfirm = React.useCallback(() => {
    handleDeleteJobs({ onShowSnackbar: handleShowSnackbar })
    handleClose()
  }, [handleClose, handleDeleteJobs, handleShowSnackbar])

  return {
    handleDeleteJobsModalClose: handleClose,
    handleDeleteJobsModalConfirm: handleConfirm,
    handleDeleteJobsModalOpen: handleOpen,
    isDeleteJobsModalOpen: isOpen,
  }
}
